import { Box, Chip, Typography, alpha, useTheme } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';
import DataTable from 'components/Common/DataTable';
import Search from 'components/Common/Search';
import { MappingRow } from '../utils/types';

interface Props {
  rows: MappingRow[];
  searchText: string | null;
  setSearchText: React.Dispatch<React.SetStateAction<string | null>>;
  isLoading?: boolean;
}

export default function TwilioMappingTable({ rows, searchText, setSearchText, isLoading }: Props) {
  const theme = useTheme();
  const columns: ColumnDef<MappingRow>[] = [
    {
      header: 'BUSINESS NAME',
      accessorKey: 'name',
      size: 320,
      minSize: 220
    },
    {
      header: 'CONNECTED NUMBER',
      accessorKey: 'numbers',
      size: 420,
      minSize: 300,
      cell: ({ row }) => {
        const numbers = row.original.numbers || [];
        if (!numbers.length) {
          return (
            <Typography fontSize={14} color='secondary'>
              No number connected yet
            </Typography>
          );
        }
        return (
          <Box display='flex' gap={1} flexWrap='wrap'>
            {numbers.map((number) => (
              <Chip
                key={number}
                size='small'
                label={number}
                sx={{
                  backgroundColor: alpha(theme.palette.primary.main, 0.12),
                  color: theme.palette.primary.main,
                  borderRadius: '999px'
                }}
              />
            ))}
          </Box>
        );
      }
    }
  ];

  return (
    <>
      <Box pb={2}>
        <Search
          placeholder='Search Business'
          size='small'
          searchText={searchText}
          setSearchText={setSearchText}
          fullWidth
        />
      </Box>
      <DataTable data={rows} columns={columns} isLoading={isLoading} />
    </>
  );
}
